import React, { Component, Suspense, lazy } from 'react'
import loadable from '@loadable/component'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/vi'
import {
  getConfigByKey,
  tenantConfig as tenantConfigs,
} from '~features/tenantConfig/services'
import * as method from '../functions/method-login'
import { insertScript } from '../functions/add-script'
import { useTheme } from '~features/theme/useTheme'
import { setUserProperties } from '~root/services/analytics/SetUserProperties'
import * as APIString from '../../constants/apiString'
import {
  setIsShowLogin,
  getPaidContent,
  resetPaymentMethod,
} from '~features/auth/services'
import onsignalService from '~root/services/onesignal/onesignalServices'
import initGTM from '~root/services/gtm/gtmServices'
import firebaseService from '~root/services/firebase/firebase'
import { PageLoading } from '~components/loading'
import OverlayLoading from '~components/loading/overlayLoading'
import BlockCountry from '~features/blockCountry/views/BlockCountry'
import pushAnalytics from '../../services/analytics/Analytics'
import AdsBanner from '~components/adsBanner/views/index'
import { AppStyled } from './styled'
import queryString from 'query-string'
import { tenantEnvConfig } from '~constants/tenantConfig/tenantEnvConfig'

import {
  initialApp,
  checkGeoBlocking,
  getMuxEnvKey,
  getRegionSubcription,
} from '../services'
import { setPreviousLocation } from '../../features/history/services'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import './main.scss'
import $ from 'jquery'
import DialogAppSubscription from '~components/svodApp/DialogAppSubscription'
import { gtmVar_setHasSubscription, gtmVar_setIsLoggedIn } from '~utils/gtm'
import { showMenu } from '~components/global/globalServices'
import { getAccountInfo } from '~features/profile/services'

window.jQuery = $
window.$ = $
global.jQuery = $
require('bootstrap')
const LoginForm = loadable(() => import('~features/auth/components/loginForm'))
const RegisterForm = loadable(() =>
  import('~features/auth/components/registerForm'),
)
const ResetPasswordForm = loadable(() =>
  import('~features/auth/components/resetPasswordForm'),
)
const MessagePopup = loadable(() =>
  import('~features/auth/components/messagePopup'),
)

const Toast = loadable(() => import('~components/toast/index'))
const Backdrop = loadable(() => import('~components/backdrop/index'))
const DefaultRouter = loadable(() => import('../components/render-router'))

class App extends Component {
  constructor(props) {
    super(props)
    this.myInterval = null
    this.countCheckSlugDomain = 0
    this.initConfig = false
    this.props.dispatchInitialApp()
    this.listAllowVerticalAds = [
      '',
      'page',
      'youtube',
      'landing',
      'search',
      'favorite',
      'genres',
      'nationalities',
      'directors',
      'casts',
      'producers',
    ]
    this.state = {
      showLoginModal: false,
      showRegisterModal: false,
      showResetPasswordModal: false,
      showMessagePopup: false,
      param: null,
      BlockCountry: false,
      isAdsVertical: window.innerWidth > 1891 ? true : false,
      allowVerticalAds: false,
    }
  }

  _initConfigs() {
    firebaseService
      .initialize()
      .then(() => {
        setUserProperties()
      })
      .catch()
    onsignalService.initialize()
    initGTM()
    insertScript(tenantConfigs)
  }

  _navigate = ({ location }) => {
    const { dpGetAccountInfo } = this.props
    dpGetAccountInfo()
    pushAnalytics('optimize.activate')
    this.props.dpSetPreviousLocation(location)
  }

  _checkAuth = () => {
    const { auth } = this.props
    const { account } = auth
    const isHasSubcription =
      auth.isHasSubcription ||
      (account && account.profile && account.profile.has_subscription) ||
      false

    gtmVar_setIsLoggedIn(auth.isLogin)
    gtmVar_setHasSubscription(isHasSubcription)
  }

  componentWillMount() {
    const { account, dpShowMenu } = this.props
    if (account && !account.profile) this.props.dispatchResetPaymentMethod()
    this._checkAuth()
    this._initConfigs()
    dpShowMenu()
    this.unlisten = this.props.history.listen((location, action) => {
      this._navigate({ location, action })
    })
  }

  componentDidMount() {
    const {
      dispatchGetRegionSubcription,
      dispatchGetPaidContent,
      account,
      location,
    } = this.props
    window.addEventListener('resize', this.updateDimensions)

    if (account && account.profile) {
      dispatchGetPaidContent().then().catch()
    }

    dispatchGetRegionSubcription()
      .then(() => {})
      .catch(() => {
        window.document.body.classList.add('v-blockRegionSubcription')
      })
    this.checkPageTypeAllowVerticalAds()
  }

  componentWillReceiveProps(nextProps) {
    const { location, account, dispatchGetPaidContent, page } = this.props
    if (
      nextProps.location.pathname !== location.pathname ||
      (page && nextProps.page.display_style !== page.display_style)
    ) {
      this.checkPageTypeAllowVerticalAds(nextProps)
      if (account && account.profile) {
        dispatchGetPaidContent().then().catch()
      }
    }
    this._checkAuth()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
    this.unlisten()
  }

  checkPageTypeAllowVerticalAds(props) {
    const { page, location } = props || this.props
    const slugType = location.pathname.split('/')[1]
    const found = this.listAllowVerticalAds.indexOf(slugType) > -1
    this.setState({
      allowVerticalAds: found && page && page.display_style !== 'LIVE',
    })
  }

  updateDimensions = () => {
    const { isAdsVertical } = this.state
    let innerWidth = window.innerWidth
    this.setState({
      isAdsVertical: innerWidth > 1891 && !isAdsVertical,
    })
  }

  render() {
    const {
      showRegisterModal,
      showResetPasswordModal,
      showMessagePopup,
      param,
      isAdsVertical,
      allowVerticalAds,
    } = this.state
    const selectedTheme = useTheme(tenantEnvConfig.ui_theme)
    const { root, auth, blockCountry } = this.props
    let skyscrapperBannerAds = getConfigByKey('features.skyscrapperBannerAds')
    moment.locale(root.language)
    if (!selectedTheme) return null

    if (blockCountry.loading) {
      return <PageLoading />
    }

    return (
      <AppStyled
        className="App"
        props={{
          isVerticalAds:
            skyscrapperBannerAds &&
            !auth.isHasSubcription &&
            allowVerticalAds &&
            !blockCountry.isBlock,
        }}
      >
        {isAdsVertical && !auth.isHasSubcription && (
          <AdsBanner position="left" customeClass="App__leftAd" />
        )}
        <div className="rootContainer">
          {blockCountry.loaded && !blockCountry.isBlock ? (
            <DefaultRouter component={this} />
          ) : (
            <BlockCountry />
          )}
          <Suspense fallback={<OverlayLoading />}>
            <LoginForm
              showForgotPassAction={() => method._showForgotPassModal(this)}
              showRegisterAction={() => method._showRegisterModal(this)}
              hideModal={key => method._hideModal(this, key)}
              modalShow={auth.isShowLogin}
              param={param}
            />

            <RegisterForm
              modalShow={showRegisterModal}
              showLoginAction={() => method._showLoginModal(this)}
              hideModal={key => method._hideModal(this, key)}
              showModal={key => method._showModal(this, key)}
            />

            <ResetPasswordForm
              modalShow={showResetPasswordModal}
              hideModal={key => method._hideModal(this, key)}
            />

            <MessagePopup
              modalShow={showMessagePopup}
              hideModal={key => method._hideModal(this, key)}
              showLoginAction={() => method._showLoginModal(this)}
            />
            <Toast />
            <Backdrop />
          </Suspense>
        </div>
        {isAdsVertical && !auth.isHasSubcription && (
          <AdsBanner position="right" customeClass="App__rightAd" />
        )}
      </AppStyled>
    )
  }
}

const mapDispatchToProps = {
  dispatchInitialApp: () => initialApp(),
  dispatchCheckGeoBlocking: () => checkGeoBlocking(),
  dispatchSetIsShowLogin: value => setIsShowLogin(value),
  dispatchGetMuxEnvKey: () => getMuxEnvKey(),
  dispatchGetRegionSubcription: () => getRegionSubcription(),
  dpSetPreviousLocation: preLocation => setPreviousLocation(preLocation),
  dispatchGetPaidContent: () => getPaidContent(),
  dispatchResetPaymentMethod: () => resetPaymentMethod(),
  dpShowMenu: () => showMenu(),
  dpGetAccountInfo: () => getAccountInfo(),
}

const mapStateToProps = state => ({
  account: state.auth.account,
  root: state.root,
  blockCountry: state.blockCountry,
  isLoading: state.loading.isLoading,
  auth: state.auth,
  tenantConfigs: state.tenantConfigs,
  page: state.home.page,
})

const connectedApp = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(App),
)
export { connectedApp as App }
